module.exports = __webpack_public_path__ + "img/foyer_button.6331516a.jpg";